
























import Vue, { PropType } from 'vue';

export const ARROW_LEFT = 'left';
export const ARROW_RIGHT = 'right';

export default Vue.extend({
  name: 'GTextLink',
  props: {
    to: String as PropType<string>,
    arrow: {
      type: String as PropType<string>,
      default: ARROW_RIGHT,
      required: false,
    },
    bold: Boolean as PropType<boolean>,
    blank: Boolean as PropType<boolean>,
  },
});
